import React from 'react';
import {
  ButtonsContainer,
  TitleAndSubtitle,
  ContentButtonsWrapper,
} from '../../../layout/layout-container.styled';
import { NavButton } from '../../../nav-button/nav-button';
import { Text, font } from '../../../../style-utils/text';
import { StyledButton } from '../../../styled-button/styled-button';
import { CheckRing } from '../../../icons/check-ring';
import { VisitorLogState } from '../../../hooks/use-visitor-log-handler';
import { DefaultComponentProps } from '../../../app-router/component-props';
import { palette } from '../../../../style-utils/theme';
import { useOptionAdvance } from '../../../hooks/use-option-advance';

export const ParkingTicketValidation: React.FC<DefaultComponentProps> = ({
  navigate,
  state,
  changeHandler,
  nextPath,
  prevPath,
}) => {
  const { parkingValidation } = state as VisitorLogState;
  const { pendingValue, selectAndAdvance } = useOptionAdvance({
    onSelect: value => changeHandler(value, 'parkingValidation', value),
    onAdvance: () => navigate(nextPath, { replace: false }),
  });

  return (
    <>
      <TitleAndSubtitle direction="column">
        <Text as="h1" fontSize={font.size.xl} fontWeight={700} mt={0} mb={8}>
          Parking Ticket Validation
        </Text>
        <Text color={font.color.gray} fontSize={font.size.xs} mt={0} mb={0}>
          Please select one of the options below
        </Text>
      </TitleAndSubtitle>
      <ContentButtonsWrapper>
        <StyledButton
          onClick={() => selectAndAdvance('Yes')}
          text={'Yes'}
          icon={<CheckRing />}
          isSelected={parkingValidation === 'Yes'}
          pending={pendingValue === 'Yes'}
        />
        <StyledButton
          onClick={() => selectAndAdvance('No')}
          text={'No'}
          icon={<CheckRing />}
          isSelected={parkingValidation === 'No'}
          pending={pendingValue === 'No'}
        />
      </ContentButtonsWrapper>
      <ButtonsContainer>
        <NavButton
          disabled={false}
          direction="back"
          textColor={palette.slate}
          background="transparent"
          text={'Back'}
          onClick={() => navigate(prevPath, { replace: false })}
        />
      </ButtonsContainer>
    </>
  );
};
